export const getIconPath = (symbol: string): string => {
    if (symbol.toLowerCase() === "pm")
        return `/assets/images/coins/${symbol.toLowerCase()}.svg`;

    return `/assets/images/coins/${symbol.toUpperCase()}.png`;
};
